export const fontFamilies = [
  'Arial',
  'monospace',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Verdana',
];
export const strokeTypes = ['None', 'Thin', 'Normal', 'Thick'];
export const fontStyles = ['normal', 'bold', 'italic'];

export const imageTypes = ['png', 'jpg', 'webp'];

export const fontSizes = [
  '10px',
  '20px',
  '30px',
  '40px',
  '50px',
  '60px',
  '70px',
  '80px',
  '90px',
  '100px',
  '120px',
  '140px',
  '160px',
  '180px',
  '200px',
];
